import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  formatNumber = (value) => {
    if (value === '-' || value === null || value === undefined) return '-';
    return parseFloat(value).toFixed(2);
  };

  render() {
    const { supplierCropData, selectedSearchValues, dateRange, fromDate, toDate} = this.props;

    const isLargeTable = dateRange.length > 15;

    const dateHeaderStyle1 = {
      border: "1px solid black",
      fontWeight: "bold",
      fontSize: "10px",
      padding: "2px",
      textAlign: "center",
      fontSize: isLargeTable ? "8px" : "10px",
      minWidth: isLargeTable ? "45px" : "80px",
      maxWidth: isLargeTable ? "45px" : "80px",
      width: isLargeTable ? "45px" : "80px",
      whiteSpace: "nowrap"
    };

    const dateCellStyle = {
      border: "1px solid black",
      padding: "2px",
      fontWeight: "bold",
      fontSize: isLargeTable ? "6px" : "10px",
      minWidth: isLargeTable ? "35px" : "40px", 
      maxWidth: isLargeTable ? "35px" : "40px",
      width: isLargeTable ? "35px" : "40px",
      whiteSpace: "nowrap"
    };

    return (
      <div id="pdf-content" style={{ width: '100%', overflowX: 'auto' }}>
        <h2 style={{ textAlign: 'left', textDecoration: 'underline' }}><center>TC 15 Supplier Wise Report</center></h2>
        <h4><center>Group - {selectedSearchValues.groupName}</center></h4>
        <h4><center>Factory - {selectedSearchValues.factoryName}</center></h4>
        <h4><center>Route - {selectedSearchValues.routeName ? selectedSearchValues.routeName : 'All Routes'}</center></h4>
        <h4><center>From Date {moment(fromDate).format("YYYY/MM/DD")} To Date {moment(toDate).format("YYYY/MM/DD")}</center></h4>

        <Table style={{ width: '100%', tableLayout: 'fixed' }} size="small">
          <TableHead>
            <TableRow >
              <TableCell style={{border: "1px solid black", borderBottom : "none", fontWeight: "bold", fontSize: "10px", padding: "2px", maxWidth: "50px", minWidth: "30px", width: "30px", whiteSpace: "normal", wordBreak: "break-all",overflowWrap: "break-word", textOverflow: "ellipsis",}} align="left">
                Reg. No
              </TableCell>
              <TableCell style={{border: "1px solid black", borderBottom : "none", fontWeight: "bold", fontSize: "10px", padding: "2px", whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-all", minWidth: "50px", maxWidth: "60px", width: "50px"}} align="left">
                Name
              </TableCell>
              <TableCell style={{border: "1px solid black", borderBottom : "none",  fontWeight: "bold", fontSize: "10px", padding: "2px", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30px"}}>
                SL Total
              </TableCell>
              <TableCell style={{border: "1px solid black", borderBottom : "none", fontWeight: "bold", fontSize: "10px", padding: "2px", maxWidth: "30px", minWidth: "30px", textAlign: 'right', width: "30px"}}>
                NL Total
              </TableCell>
              <TableCell style={{border: "1px solid black", borderBottom : "none", fontWeight: "bold", fontSize: "10px", padding: "2px", maxWidth: "30px", minWidth: "30px", textAlign: 'center', width: "30px"}}>
                Total
              </TableCell>

                {dateRange.map((date, index) => (
                  <TableCell key={index} colSpan={2} style={dateHeaderStyle1} align="center">
                    {date.month}-{date.day}
                  </TableCell>
                ))}                
            </TableRow>
            <TableRow>
              <TableCell style={{ border : "1px solid black" ,borderBottom : "1px solid black", borderTop: "none", borderRight: "1px solid black" }}></TableCell>
              <TableCell style={{ borderBottom : "1px solid black", borderRight: "1px solid black" }}></TableCell>
              <TableCell style={{ border: "1px solid black", borderTop: "none", fontWeight: "bold", fontSize: "10px", padding: "2px", minWidth: "30px", maxWidth: "30px",  width: "30px",  whiteSpace: "nowrap"}} align="center">/kg</TableCell>
              <TableCell style={{ border: "1px solid black", borderTop: "none", fontWeight: "bold", fontSize: "10px", padding: "2px", minWidth: "30px", maxWidth: "30px",  width: "30px",  whiteSpace: "nowrap"}} align="center">/kg</TableCell>
              <TableCell style={{ border: "1px solid black", borderTop: "none", fontWeight: "bold", fontSize: "10px", padding: "2px", minWidth: "30px", maxWidth: "30px",  width: "30px",  whiteSpace: "nowrap"}} align="center">/kg</TableCell>

              {dateRange.map((date, index) => {
                return (
                  <React.Fragment key={index}>
                  <TableCell style={{border: "1px solid black", borderTop: "none", fontWeight: "bold", fontSize: "10px", padding: "2px", minWidth: "30px", maxWidth: "30px",  width: "30px",  whiteSpace: "nowrap"}} align="center">
                     SL
                  </TableCell>
                  <TableCell style={{border: "1px solid black", borderTop: "none", fontWeight: "bold", fontSize: "10px", padding: "2px", minWidth: "30px", maxWidth: "30px",  width: "30px",  whiteSpace: "nowrap"}} align="center">
                     NL
                  </TableCell>
                </React.Fragment>
                );
              })}
            </TableRow>

          </TableHead>
          <TableBody>
            {Object.entries(supplierCropData).map(([index, row]) => (
              <TableRow key={index}>
                <TableCell style={{border: "1px solid black", fontSize: "8px",fontWeight: "bold", padding: "2px", maxWidth: "30px", minWidth: "30px",width: "30px", whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-all"}} align="left">
                  {row.registrationNumber}
                </TableCell>
                <TableCell style={{border: "1px solid black", fontSize: "8px",fontWeight: "bold", padding: "2px", minWidth: "60px", maxWidth: "60px",width: "50px", whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-all"}} align="left">
                  {row.name}
                </TableCell>
                <TableCell style={{border: "1px solid black", fontSize: "7px",fontWeight: "bold", padding: "2px", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30px"}} align="right">
                  {row.slQuantity === 0 ? '-' : this.formatNumber(row.slQuantityTotal)}
                </TableCell>
                <TableCell style={{border: "1px solid black", fontSize: "7px", fontWeight: "bold",padding: "2px", textAlign: 'right', maxWidth: "30px", minWidth: "30px",width: "30px"}} align="right">
                  {row.nlQuantity === 0 ? '-' : this.formatNumber(row.nlQuantityTotal)}
                </TableCell>
                <TableCell style={{border: "1px solid black", fontSize: "7px",fontWeight: "bold", padding: "2px", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30px"}} align="right" >
                  {this.formatNumber(row.total)}
                </TableCell>

                {dateRange.map((date, index) => {
                  const formattedDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
                  const matchingRecord = row.details.filter(detail => detail.collectedDate === formattedDate);

                  const sl = matchingRecord.find(rec => rec.nlQuantity === 0)?.slQuantity ?? '-';
                  const nl = matchingRecord.find(rec => rec.slQuantity === 0)?.nlQuantity ?? '-';

                  return (
                    <React.Fragment key={index}>
                      <TableCell style={dateCellStyle} align={sl === '-' ? "center" : "right"}>
                        {sl === '-' ? '-' : this.formatNumber(sl)}
                      </TableCell>
                      <TableCell style={dateCellStyle} align={nl === '-' ? "center" : "right"}>
                        {nl === '-' ? '-' : this.formatNumber(nl)}
                      </TableCell>
                    </React.Fragment>
                  );
                })}
              </TableRow>
            ))}

            <TableRow>
              <TableCell style={{border: "1px solid black", fontWeight: "bold", fontSize: "10px", padding: "2px", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30px"}} align="center">
                Total
              </TableCell>
              <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "7px", padding: "2px", maxWidth: "30px", minWidth: "30px", textAlign: 'right', width: "30px"}} align="left"
              />
              <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "7px", padding: "2px", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30px"}} align="right">
                {this.formatNumber(
                  Object.entries(supplierCropData).reduce(
                    (sum, [, row]) => sum + (row.slQuantityTotal || 0),
                    0
                  )
                )}
              </TableCell>

              <TableCell style={{ border: "1px solid black", fontSize: "7px", padding: "2px",fontWeight: "bold", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30px"}} align="right">
                {this.formatNumber(
                  Object.entries(supplierCropData).reduce(
                    (sum, [, row]) => sum + (row.nlQuantityTotal || 0),
                    0
                  )
                )}
              </TableCell>

              <TableCell
                style={{ border: "1px solid black", fontSize: "7px", padding: "2px", textAlign: 'right',fontWeight: "bold", maxWidth: "30px", minWidth: "30px", width: "30px"}}align="right">
                {this.formatNumber(
                  Object.entries(supplierCropData).reduce(
                    (sum, [, row]) => sum + (row.total || 0),
                    0
                  )
                )}
              </TableCell>

              {dateRange.map((date, index) => {
                  const formattedDate = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;

                  let totalSlQuantity = 0;
                  let totalNlQuantity = 0;

                    Object.values(supplierCropData).forEach((row) => {
                        if (row.details) {
                            row.details.forEach((detail) => {
                              if (detail.collectedDate === formattedDate) {
                                totalSlQuantity += Number(detail.slQuantity) || 0;
                                totalNlQuantity += Number(detail.nlQuantity) || 0;
                              }
                            });
                        }
                    });

                return (
                  <React.Fragment key={index}>
                    <TableCell
                      style={{ border: "1px solid black",  fontSize: isLargeTable ? "6px" : "10px", padding: "2px",fontWeight: "bold", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30p"}} 
                      align={totalSlQuantity === 0 ? "center" : "right"}>
                      {totalSlQuantity === 0 ? '-' : this.formatNumber(totalSlQuantity)}
                    </TableCell>
                    <TableCell
                      style={{ border: "1px solid black",  fontSize: isLargeTable ? "6px" : "10px", padding: "2px", fontWeight: "bold", textAlign: 'right', maxWidth: "30px", minWidth: "30px", width: "30px"}}
                      align={totalNlQuantity === 0 ? "center" : "right"}>
                      {totalNlQuantity === 0 ? '-' : this.formatNumber(totalNlQuantity)}
                    </TableCell>
                  </React.Fragment>
                );
              })}
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }
}
